export default __webpack_public_path__ + "static/media/category-icon-Industry.723fa504.svg";